import { Grid, IconButton } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import { useTemplateStyles } from "@saleor/dropOff/styles/templates";
import React from "react";

export interface DropOffTaskAreaAddRemoveButtonProps {
  disableAssignButton: boolean;
  disableRemoveButton: boolean;
  onclickAssignTenant: () => void;
  onclickRemoveTenant: () => void;
}

const DropOffTaskAreaAddRemoveButton: React.FC<DropOffTaskAreaAddRemoveButtonProps> = props => {
  const {
    disableAssignButton,
    disableRemoveButton,
    onclickAssignTenant,
    onclickRemoveTenant
  } = props;

  const classes = useTemplateStyles(props);

  return (
    <Grid
      xs={2}
      item
      container
      direction="column"
      alignItems="center"
      justify="center"
    >
      <IconButton
        aria-label="back"
        className={
          disableAssignButton
            ? classes.buttonColorDisabled
            : classes.buttonColor
        }
        onClick={onclickAssignTenant}
        disabled={disableAssignButton}
      >
        <ArrowForwardIcon className={classes.textWhite} />
      </IconButton>
      <IconButton
        aria-label="back"
        className={
          disableRemoveButton
            ? classes.buttonColorDisabled
            : classes.buttonColor
        }
        style={{ marginTop: 20 }}
        onClick={onclickRemoveTenant}
        disabled={disableRemoveButton}
      >
        <ArrowBackIcon className={classes.textWhite} />
      </IconButton>
    </Grid>
  );
};

DropOffTaskAreaAddRemoveButton.displayName = "DropOffTaskAreaAddRemoveButton";
export default DropOffTaskAreaAddRemoveButton;
